import { render, staticRenderFns } from "./NewAnswer.vue?vue&type=template&id=91bc8e6e&scoped=true&"
import script from "./NewAnswer.vue?vue&type=script&lang=js&"
export * from "./NewAnswer.vue?vue&type=script&lang=js&"
import style0 from "./NewAnswer.vue?vue&type=style&index=0&id=91bc8e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bc8e6e",
  null
  
)

export default component.exports